module.exports = __webpack_public_path__ + "static/img/shopcode.e5fb6eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shopcode.png
// module id = AOce
// module chunks = 1